module.exports = __webpack_public_path__ + "img/product-ketang-kjxl-05.82a65cfd.png";